<template>
  <Header title="features" />
  <FeatureGrid title="Our Features" :features="features" label="" />
</template>

<script>
import FeatureGrid from "../../components/layouts/FeatureGrid.vue";
import FeatureGridList from "../../components/layouts/FeatureGridList.vue";
import Container from "@/components/base/Container";
import Header from "@/components/base/Header";
import {
  AnnotationIcon,
  GlobeAltIcon,
  LightningBoltIcon,
  ScaleIcon,
} from "@heroicons/vue/outline";

const features = [
  {
    name: "Driver Identification",
    description:
      " We have many different options available to effectively track driver identification.",
    list: [
      "RFID ( Card or Fob )",
      "Keep Record of driver information ( License Number, Expiry Date )",
    ],
    icon: GlobeAltIcon,
  },
  {
    name: "Customization",
    description: `All our products are based on the premise that we can expand on your
        services as your fleet demands it. We use only quality hardware that has
        the fundamental base to expand to a fully comprehensive solution.`,
    icon: ScaleIcon,
  },
  {
    name: "Email Alerts",
    description: `We offer email notifications to fit the customers demands. Some types of notifications include:`,
    list: [
      "Speeding Alerts",
      "Geo Zone arrival/departures",
      "Input Notifications",
    ],
    icon: LightningBoltIcon,
  },
  {
    name: "Geo-Zone",
    description: `A user can create separate Geo-Zones including name and location. They
        can also add/remove zones as needed. As job sites change and off-site
        information for an employee’s arrival/departure is a must to track
        off-site operations.`,
    icon: AnnotationIcon,
  },
  {
    name: "HOS ( Hours of Service) / ELD ( Electronic Logging Device )",
    description: `Upgrading your business to become compliant to the new ELD mandate has
        just become an easy addition with Ultrack solution.`,
    icon: GlobeAltIcon,
  },
  {
    name: "Multiple Tracking Options",
    description: `Ultrack’s robust platform options allows you to track everything on the
        same account. 
        Versatility is what we offer to give you the best options to suit
        business / personal demands. 
        Whether you’re tracking your generator on a remote site or simple cell
        phone, it can all become easy to track on our platform.`,
    icon: ScaleIcon,
  },
  {
    name: "Multiple User Accounts",
    description: `We have the ability to create multiple user accounts for you and your
        employees. If you have a client that needs to share a view or see some of
        your units then we can grant access with limited viewing of just the
        units you want to see.`,
    icon: LightningBoltIcon,
  },
  {
    name: "Platform Viewing",
    description: `Our application can be viewed from any web browser. This makes access to
        your account much more convenient and with our mobile friendly apps;
        give you access through your smartphone or tablet.`,
    icon: AnnotationIcon,
  },
  {
    name: "Reports",
    description: `Ultracks portal provides you with various reports that you would need to
        manage your fleet. Whether its 1 or 1000 + it is easy to track. Our reports are broken down
        by Device, Fleet or Zone.`,
    icon: GlobeAltIcon,
  },
  {
    name: "Temperature Monitoring",
    description: `Reefer trailers are ideal for the U304. Our platform can display up to 8 sensors per trailer and give you continually readings to ensure your product is at a consistent temperature. We can create separate user accounts for your customers to monitor their loads if required.`,
    icon: ScaleIcon,
  },
];

export default {
  components: {
    Container,
    Header,
    FeatureGridList,
    FeatureGrid,
  },
  setup() {
    return { features };
  },
};
</script>

<style>
.icon-container {
  display: grid;
  place-items: center;
  width: 3rem;
  height: 3rem;
  border-radius: 0.375rem;

  background: rgb(0, 123, 136);
  color: rgb(249, 254, 255);
  margin-bottom: 1rem;
}
</style>
